<template>
  <b-overlay
    variant="white"
    spinner-variant="primary"
    blur="0"
    opacity="0.75"
    rounded="sm"
    :show="loading"
  >
    <b-card
      v-if="userDetails"
      no-body
      class="p-1"
    >
      <b-row>
        <b-col
          v-for="(item , i) in pickDetails"
          :key="i"
          md="3"
          class="d-flex align-items-center"
        >
          <div class="d-flex align-items-center">
            <feather-icon
              :icon="item.icon"
              class="mr-75"
            />
            <span class="font-weight-bold mr-1">{{ item.label }}:</span>
            {{ userDetails[item.key] }}

          </div>
        </b-col>
        <b-col
          v-if="viewdIn"
          md="3"
          class="d-flex justify-content-end"
        >
          <b-button
            class="btn-icon rounded-circle ml-1"
            variant="flat-primary"
            @click="$emit(`refetch-${viewdIn}`)"
          >
            <feather-icon
              icon="RefreshCwIcon"
            />
          </b-button>
        </b-col>
      </b-row>
    </b-card>
  </b-overlay>
</template>

<script>
import {
  BCard, BRow, BCol, BOverlay, BButton,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BOverlay,
    BButton,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    userDetails: {
      type: Object,
      default: null,
    },
    viewdIn: {
      type: String,
      default: undefined,
    },
  },
  setup() {
    const pickDetails = [
      {
        key: 'firstName',
        label: 'First Name',
        icon: 'StarIcon',
        pickFrom: 'userDetails',
      },
      {
        key: 'lastName',
        label: 'Last Name',
        icon: 'StarIcon',
        pickFrom: 'userDetails',
      },
      {
        key: 'phoneNumber',
        label: 'Phone Number',
        icon: 'PhoneIcon',
        pickFrom: 'userDetails',
      },
    ]
    return {
      pickDetails,
    }
  },
}
</script>

<style>

</style>
